import React, { Component } from "react";
import PropTypes from "prop-types";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import * as Theme from "../../../app/Theme";
import * as HLConst from "../NonVisual/HLConst";
import HLNavBtnDiv from "../Other/HLNavBtnDiv";
import image from "../../../img/mothers with children.jpg";

class HLStep4Form extends Component {
    static propTypes = {
        onPageChange: PropTypes.func,
    };

    static defaultProps = {
        onPageChange: () => console.log("onPageChange"),
    };

    state = {};

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onPageChange = (pageID) => {
        this.props.onPageChange(pageID);
    };

    onTemplatesClick = () => {
        window.open("./resources/" + HLConst.templatesXLSX, "_blank");
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderTextDiv = () => {
        let textDiv = (
            <div
                style={{
                    ...Theme.textFontStyle,
                    // backgroundColor : Theme.HL_PrimaryColor,
                    // color           : "white",
                    marginLeft: Theme.leftIndent,
                }}
            >
                <p
                    style={{
                        ...Theme.pageHeadingFontStyle,
                        ...Theme.pageHeadingWithBannerStyle,
                    }}
                >
                    {HLConst.step4AreaText1}
                    &nbsp;
                    {/*<span style = {Theme.stepSubTextHeadingFontStyle}>*/}
                    {HLConst.step4AreaText2}
                    {/*</span>*/}
                </p>

                <Divider
                    style={{
                        ...Theme.dividerStyle,
                    }}
                />

                <p>
                    For each activity identified in step 3, think through the inputs for that activity which represent
                    incremental costs. Incremental costs are additional resources (e.g., radio spots, materials) that
                    would be needed beyond what is already available and budgeted (e.g., an existing health facility or
                    employed nurse).
                </p>

                <ul>
                    <li>
                        Think about possibilities to reallocate existing resources, knowing that additional funds may be
                        unlikely to become available
                    </li>
                    <li
                        style={{
                            marginLeft: Theme.bulletListIndent2,
                        }}
                    >
                        e.g., a nurse in antenatal care who is not busy in the afternoon could work during those hours
                        in the maternity ward instead
                    </li>
                    <li>
                        Consider potential cost savings by integrating activities (e.g., using the same community health
                        workers for WASH and nutrition-related activities)
                    </li>
                    <li>
                        Some activities may seem expensive as they represent one-time startup or capital expenditures;
                        to best compare with other interventions which are likely recurrent (yearly) costs, think about
                        their approximate annual cost
                    </li>
                    <li
                        style={{
                            marginLeft: Theme.bulletListIndent2,
                        }}
                    >
                        e.g., buildings or vehicles; total purchase price might be $30,000 but if you use the item for
                        five years, the approximate annual cost is $6,000 x 5 years = $30,000
                    </li>
                    <li
                        style={{
                            marginLeft: Theme.bulletListIndent2,
                        }}
                    >
                        Although for comparison purposes the one-off and yearly recurrent costs may be similar, you will
                        consider in a later step if you have the current resource availability to incur the one-off
                        expense now
                    </li>
                </ul>

                <p>
                    Download our&nbsp;
                    <Link
                        onClick={this.onTemplatesClick}
                        style={{
                            color: Theme.HL_LinkBlue,
                            cursor: "pointer",
                        }}
                        underline={"hover"}
                    >
                        incremental costing template
                    </Link>
                    &nbsp;to help you with the incremental costing.
                </p>

                <div
                    style={{
                        ...Theme.exampleDivStyle,
                    }}
                >
                    <p>
                        <span
                            style={{
                                textDecoration: "underline",
                            }}
                        >
                            For example:
                        </span>
                        &nbsp;Your number one prioritized intervention from step 2 is treatment for moderate acute
                        malnutrition (MAM) and your identified activity from step 3 is community sensitization. You
                        already have community health workers who can undertake community sensitization, but you need to
                        budget for the development of materials and training.
                    </p>
                </div>
            </div>
        );

        return textDiv;
    };

    render() {
        const navBtnDiv = (
            <HLNavBtnDiv
                onBackBtnClick={() => this.onPageChange(HLConst.step3Form)}
                onNextBtnClick={() => this.onPageChange(HLConst.step5Form)}
            />
        );

        // const downloadGuideBtn =
        //     <HLDownloadGuideBtn/>;

        return (
            <div
                style={{
                    minHeight: window.innerHeight - Theme.HL_FooterOffset, //Theme.HL_FooterPosition,
                }}
            >
                <img
                    style={{
                        width: "calc(100% - 1px)",
                    }}
                    src={image}
                    alt=""
                />

                {this.renderTextDiv()}
                {/*{downloadGuideBtn}*/}
                {navBtnDiv}
            </div>
        );
    }
}

export default HLStep4Form;
